import { rem } from 'polished';
import styled, { css } from 'styled-components';

const Container = styled.div`
  margin: 0 auto;
  max-width: 100%;
  padding: 0;
  width: ${rem(1040)};

  ${props => props.theme.mediaQuery('lg')} {
    padding: 0 ${rem(16)};
  }
`;

const bannerBg = css`
  position: relative;
  z-index: 1;

  &::after {
    background-color: ${props => props.theme.colors.red};
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;

    ${props => props.theme.mediaQuery('lg', 'min')} {
      transform: translateX(calc((100vw - 1012px) / -2));
      width: 100vw;
    }
  }
`;

export { bannerBg, Container };
